if (!customElements.get('product-usps')) {
  class ProductUsps extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-usps-track]');
      this.cards = Array.from(this.querySelectorAll('[data-product-usp-card]'));
      this.index = 0;
      this.interval = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.resizeObserver = null;

      if (!this.track || this.cards.length < 2) {
        return;
      }

      this.onLayoutChange = this.onLayoutChange.bind(this);
      this.pause = this.pause.bind(this);

      this.motionQuery.addEventListener('change', this.onLayoutChange);
      this.addEventListener('pointerdown', this.pause);
      this.addEventListener('focusin', this.pause);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onLayoutChange);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.onLayoutChange);
      }

      this.onLayoutChange();
    }

    disconnectedCallback() {
      this.stop();

      if (this.motionQuery) {
        this.motionQuery.removeEventListener('change', this.onLayoutChange);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', this.onLayoutChange);
      }

      this.removeEventListener('pointerdown', this.pause);
      this.removeEventListener('focusin', this.pause);
    }

    onLayoutChange() {
      this.stop();

      if (this.shouldRotate()) {
        this.interval = window.setInterval(() => {
          this.index = (this.index + 1) % this.cards.length;
          this.track.scrollTo({
            left: this.cards[this.index].offsetLeft,
            behavior: 'smooth'
          });
        }, 3800);
      }
    }

    shouldRotate() {
      var trackStyle = window.getComputedStyle(this.track);
      var isCarousel = trackStyle.display === 'flex';
      var hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;

      return isCarousel && hasOverflow && !this.motionQuery.matches;
    }

    pause() {
      this.stop();
    }

    stop() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  customElements.define('product-usps', ProductUsps);
}
